import mockAxios, { AxiosResponse } from 'axios';

import { IVendorServiceMock } from './vendor.mock.types';

export const mockVendorService = (): IVendorServiceMock => ({
  fetchVendors: jest.fn(),
  fetchVendor: jest.fn(),
  createVendor: jest.fn(),
  updateVendor: jest.fn(),
  deleteVendor: jest.fn(),
  uploadVendorFile: jest.fn()
});

export const mockVendorAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
